// Package Imports
import moment from 'moment';

// Project Imports
import SocketEvent from 'core/constants/SocketEvent';
import openNotificationWithIcon from 'core/utils/notification';
import useLogger from 'core/utils/useLogger';

function updateOrAddNotificationMsg(notificationArray, newNotificationMsg) {
  // Find the index of the object that has the matching key and value
  const index = notificationArray?.findIndex(
    (obj) => obj?.uniqueId === newNotificationMsg?.uniqueId
  );

  if (index !== -1) {
    // If newNotificationMsg is found in notificationArray, update the process with new newNotificationMsg
    // eslint-disable-next-line no-param-reassign
    notificationArray[index] = newNotificationMsg;
  } else {
    // If newNotificationMsg is not found, add the newNotificationMsg to the notificationArray
    notificationArray?.push(newNotificationMsg);
  }

  return notificationArray;
}

const updateNotifications = (
  newMessage,
  userId,
  id,
  setNotificationMessages
) => {
  const updatedNewMessage = { ...newMessage };
  if (updatedNewMessage.timestamp) {
    const adjustedTimestamp = moment(updatedNewMessage.timestamp)
      .add(5, 'hours')
      .add(30, 'minutes')
      .format('YYYY-MM-DD HH:mm:ss');
    updatedNewMessage.timestamp = adjustedTimestamp;
  }
  const notificationList = localStorage.getItem('notifications');
  const notificationLocalstorage =
    JSON.parse(notificationList)?.length > 0
      ? JSON.parse(notificationList)
      : [];
  const updatedMessages = updateOrAddNotificationMsg(
    notificationLocalstorage,
    updatedNewMessage
  );
  if (updatedMessages?.length > notificationLocalstorage?.length) {
    // show notification if new message added
    openNotificationWithIcon(
      updatedNewMessage.status,
      updatedNewMessage?.title,
      updatedNewMessage?.message
    );
  }
  if (userId === id) {
    localStorage.setItem('notifications', JSON.stringify(updatedMessages));
    setNotificationMessages(updatedMessages);
  }
};
const fetchNotificatons = async (
  setNotificationMessages,
  userDetails,
  socketInstance
): Promise<void> => {
  try {
    socketInstance.on(SocketEvent?.ORGANIZATION_CREATION_EVENT_NAME, (data) => {
      console.log('data socket ', data);
      const newMessage = {
        title: data?.event_name,
        timestamp: data?.date_time,
        message: data?.message,
        status: data?.status,
        userId: data?.userId,
        progress: data?.completion_percentage,
        uniqueId: data?.workflow_status_id,
        read: false,
        extraKeys: data?.extra_keys,
      };
      updateNotifications(
        newMessage,
        userDetails?.unique_id,
        data?.userId,
        setNotificationMessages
      );
    });
  } catch (error) {
    const logger = useLogger();
    logger('error socket ', error);
  }
};

export default fetchNotificatons;
